import { render, staticRenderFns } from "./zbEdit.vue?vue&type=template&id=4770aff8&"
import script from "./zbEdit.vue?vue&type=script&lang=js&"
export * from "./zbEdit.vue?vue&type=script&lang=js&"
import style0 from "./zbEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "zbEdit.vue"
export default component.exports